import { Component } from "react";
import logo from '../../img/logo.svg';
import avatar from '../../img/avatar.svg'
import dashboard from '../../img/dashboard.png'
import settings from '../../img/settings.png'
import user from '../../img/operation.png'
import operation from '../../img/operation.png'
import activity from '../../img/activity.png'
import fuelstation from '../../img/fuel-station.png'
import purchasing from '../../img/purchasing.png'
import dispenser from '../../img/dispenser.png'
import fueltruck from '../../img/fuel-truck.png'
import scale from '../../img/scale.png'
import fuel from '../../img/fuel.png'
import tank from '../../img/tank.png'
import { Link } from "react-router-dom";
import { useState } from 'react';
const Admin_Sidebar_Progress = ({ progress = 0 }) => {
  const [show7, setShow7] = useState(false)
  return (
    <div className="left-wrap p-0">
      <div className="d-flex">
        <div className="logo-wrp">
          <a className="logo-continer text-center" href="#"><img src={logo} /></a>
        </div>

      </div>
      <div className="responsive">
        <div className="profile-pic" style={{ display: 'none' }}>
          <img src={avatar} className="img-fluid" alt="" />
        </div>

      </div>

      <ul className="sidemenu">

        <li className={progress == 18 ? "active" : ""}>
          <Link to="/admin_dashboard" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-speedometer2" viewBox="0 0 16 16">
                  <path d="M8 4a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-1 0V4.5A.5.5 0 0 1 8 4zM3.732 5.732a.5.5 0 0 1 .707 0l.915.914a.5.5 0 1 1-.708.708l-.914-.915a.5.5 0 0 1 0-.707zM2 10a.5.5 0 0 1 .5-.5h1.586a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 10zm9.5 0a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5zm.754-4.246a.389.389 0 0 0-.527-.02L7.547 9.31a.91.91 0 1 0 1.302 1.258l3.434-4.297a.389.389 0 0 0-.029-.518z"/>
                  <path fillRule="evenodd" d="M0 10a8 8 0 1 1 16 0A8 8 0 0 1 0 10zm7.5-7.5v2.5a.5.5 0 0 0 1 0V2.5A.5.5 0 0 0 8 2.5z"/>
                </svg><span className="ms-2">Control Center</span>
              </p></Link>
        </li> 
        <li className={progress == 23 ? "active" : ""}>
          <Link to="/admin-pumps-details" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-fuel-pump" viewBox="0 0 16 16">
                  <path d="M3 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5Z"/>
                  <path d="M1 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v8a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2V2Zm13 2v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1Z"/>
                </svg><span className="ms-2">Pumps Activity</span>
              </p></Link>
        </li>
        <li className={progress == 24 ? "active" : ""}>
          <Link to="/admin-user-management" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                  <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1h8Zm-7.978-1A.261.261 0 0 1 7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002a.274.274 0 0 1-.014.002H7.022ZM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6.936 9.28a5.88 5.88 0 0 0-1.23-.247A7.35 7.35 0 0 0 5 9c-4 0-5 3-5 4 0 .667.333 1 1 1h4.216A2.238 2.238 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816ZM4.92 10A5.493 5.493 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"/>
                </svg><span className="ms-2">User Management</span>
              </p></Link>
        </li>
        <li className={progress == 30 ? "active" : ""}>
          <Link to="/admin-support" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-ticket-detailed" viewBox="0 0 16 16">
                  <path d="M4 5.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM4 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 4 8Z"/>
                  <path d="M0 4.5A1.5 1.5 0 0 1 1.5 3h13A1.5 1.5 0 0 1 16 4.5V6a.5.5 0 0 1-.5.5 1.5 1.5 0 0 0 0 3 .5.5 0 0 1 .5.5v1.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 11.5V10a.5.5 0 0 1 .5-.5 1.5 1.5 0 1 0 0-3A.5.5 0 0 1 0 6V4.5ZM1.5 4a.5.5 0 0 0-.5.5v1.05a2.5 2.5 0 0 1 0 4.9v1.05a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1.05a2.5 2.5 0 0 1 0-4.9V4.5a.5.5 0 0 0-.5-.5h-13Z"/>
                </svg><span className="ms-2">Support Tickets</span>
              </p></Link>
        </li>
        <li className={progress == 19 ? "active" : ""}>
          <Link to="/pump_name" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                </svg><span className="ms-2">Set Pump</span>
              </p></Link>
        </li>
        <li className={progress == 20 ? "active" : ""}>
          <Link to="/admin-role-list" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                </svg><span className="ms-2">Role management</span>
              </p></Link>
        </li>
        <li className={progress == 33 ? "active" : ""}>
          <Link to="/permission" className="text-white text-decoration-none">
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                  <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                  <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                </svg><span className="ms-2">Permission management</span>
              </p></Link>
        </li>
        <li className={progress == 21 ? "active" : ""}>
          <Link to="/admin-subscription-management" className="text-white text-decoration-none">
              <p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bookmark-fill" viewBox="0 0 16 16">
                <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
              </svg><span className="ms-2">Subscription Management</span></p></Link>
        </li>
        <li className={progress == 32 ? "active" : ""}>
          <Link to="/admin-payment-management" className="text-white text-decoration-none">
              <p><span className="ms-2">💳 Payment Management</span></p></Link>
        </li>
        <li className={progress == 25 ? "active" : ""}>
          <Link to="/admin-alerts" className="text-white text-decoration-none"><p><span className="ms-2">🔔 Alerts Center</span></p></Link>
        </li>
        <li className={progress == 35 ? "active" : ""}>
          <Link to="/admin-system-monitoring" className="text-white text-decoration-none"><p><span className="ms-2">🖥️ System Monitoring</span></p></Link>
        </li>
        <li className={progress == 34 ? "active" : ""}>
          <Link to="/admin-ledger-errors" className="text-white text-decoration-none"><p><span className="ms-2">Ledger Errors</span></p></Link>
        </li>
        <li className={progress == 36 ? "active" : ""}>
          <Link to="/admin-tank-stock-errors" className="text-white text-decoration-none"><p><span className="ms-2">Tank Stock Errors</span></p></Link>
        </li>
        <li className={progress == 27 ? "active" : ""}>
          <Link to="/admin-analytics" className="text-white text-decoration-none"><p><span className="ms-2">📊 Platform Analytics</span></p></Link>
        </li>
        <li className={progress == 31 ? "active" : ""}>
          <Link to="/admin-business-insights" className="text-white text-decoration-none"><p><span className="ms-2">💡 Business Insights</span></p></Link>
        </li>
        <li className={progress == 26 ? "active" : ""}>
          <Link to="/admin-audit-log" className="text-white text-decoration-none"><p><span className="ms-2">📋 Audit Log</span></p></Link>
        </li>
        <li className={progress == 29 ? "active" : ""}>
          <Link to="/admin-master-settings" className="text-white text-decoration-none"><p><span className="ms-2">⚙️ Master Settings</span></p></Link>
        </li>
        <li className={progress == 28 ? "active" : ""}>
          <Link to="/admin-invoice-settings" className="text-white text-decoration-none"><p><span className="ms-2">🧾 Invoice Settings</span></p></Link>
        </li>

        <li>
          <button type="button" onClick={() => setShow7(!show7)} className="text-white border-0 bg-transparent w-100 text-start p-0">
            <p>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg><span className="ms-2">About us</span></p>
          </button>
          {show7 ?
            <ul className="sidesubmenu">
              <li>
                <span className="dropdown-toggle let text-white"><p>
                    <span className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>About PetroSmart</span></p></span>
              </li>
              <li>
                <span className="dropdown-toggle let text-white"><p>
                    <span className="ms-5"><i className="fa fa-angle-double-right " aria-hidden="true"></i>Privacy policies</span></p></span>
              </li>
            </ul>
            : null}
        </li>

      </ul>
      {/* <a href="#" className="btm-corner"><strong><i className="fa fa-question-circle-o p-2"></i>Help</strong></a> */}
    </div>
  )


}


export default Admin_Sidebar_Progress;
export const convertAmountToWords = (e, nums) => {
  var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ', 'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
  var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  var myArr = nums.split(".");
  var num = myArr[0];
  var num1 = myArr[1] ? myArr[1] : '';
  if ((num = num.toString()).length > 9) return 'overflow';
  /****************************/
  var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);

  if (!n) return; var str = '';
  str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
  str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
  str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
  str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'And ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + ' ' : '';
  // var selector = document.getElementsByClassName('amount-words')
  /************************* */
  if (num1 != '') {
    if ((num1 = num1.toString()).length > 2) return 'overflow';
  }

  /****************************/
  var p = ('000000000' + num1).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  console.log(p);
  var str1 = '';
  if ((p) && (num1 != '')) {
    str1 += (p[5] != 0) ? ((str1 != '') ? 'And ' : '') + (a[Number(p[5])] || b[p[5][0]] + ' ' + a[p[5][1]]) + ' ' : '';
  }
  /************************* */
  var parent = e.currentTarget.parentNode
  var selector = parent.querySelector('.amount-words')
  if (typeof selector !== 'undefined' && selector) {
    if(str1 !='')
		{
			 if(str =='')
			 {
				 str = 'Zero';
			 }
		str = str+' Rupees And '+str1+' Paise ';
		}
		if(str !='' && num != 1 && num != 0){
		str = str+' Rupees';
		}
		else if(num == 0 && str1 =='')
		{
		  str = str+' Zero';
		}
		else if(num == 1 && str1 =='')
		{
		  str = str+' Rupee';
		}	
    selector.innerHTML = str;
  }


}

export const preventNonNumericalInput=(e,num) =>{
  
  e = e || window.event;
  var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
  var charStr = String.fromCharCode(charCode);
  var fullChar = num ? num?.toString() + charStr : charStr;
  if (!fullChar.match(/^[0-9]*(\.{1})?([0-91-9][0-9])?$/))
  e.preventDefault();

  var myArr =fullChar.toString().split('.');
  var num0 = myArr[0];
  if ((num0 = num0.toString()).length > 8)
  e.preventDefault();
  }

  export const prevNonNumericalWithDec=(e,num) =>{

   var parent = e.currentTarget.parentNode
   var selector = parent.querySelector('.ph_no')
   if (typeof selector !== 'undefined' && selector)
     {
       e = e || window.event;
       var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
       var charStr = String.fromCharCode(charCode);
       var fullChar = num ? num?.toString() + charStr : charStr;
       if (!fullChar.match(/^[0-9]+$/))
       e.preventDefault();
     }
     else
     {
       e = e || window.event;
       var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
       var charStr = String.fromCharCode(charCode);
       var fullChar = num ? num?.toString() + charStr : charStr;
       if (!fullChar.match(/^[0-9]+$/))
       e.preventDefault();

       var myArr =fullChar.toString().split('.');
       var num0 = myArr[0];
       if ((num0 = num0.toString()).length > 8)
       e.preventDefault();

     }
   }